import { useMemo, useState } from 'react';
import { HexMapCanvas } from '../ui/HexMap/HexMapCanvas';
import { MenuScreen } from '../ui/Menu/MenuScreen';
import { TUTORIALS } from '../tutorials/tutorials';
import { loadGameConfig, type GameConfig } from '../config/gameConfig';
import { t } from '../i18n/translations';
import './styles.css';

const App = () => {
    const [mode, setMode] = useState<'menu' | 'game'>('menu');
    const [menuView, setMenuView] = useState<'main' | 'tutorials'>('main');
    const [tutorialId, setTutorialId] = useState<string | null>(null);
    const [configOverride, setConfigOverride] = useState<Partial<GameConfig> | null>(null);

    const lang = loadGameConfig().ui.language;

    const activeTutorial = useMemo(
        () => (tutorialId ? TUTORIALS.find((entry) => entry.id === tutorialId) || null : null),
        [tutorialId],
    );

    const startSandbox = () => {
        setTutorialId(null);
        setConfigOverride(null);
        setMode('game');
    };

    const startTutorial = (id: string) => {
        const tutorial = TUTORIALS.find((entry) => entry.id === id);
        if (!tutorial) return;
        setTutorialId(id);
        setConfigOverride(tutorial.configOverrides);
        setMode('game');
    };

    const openTutorials = () => setMenuView('tutorials');
    const backToMain = () => setMenuView('main');
    const quitTutorial = () => {
        setTutorialId(null);
        setConfigOverride(null);
    };

    return (
        <div className="app">
            {mode === 'menu' ? (
                <MenuScreen
                    lang={lang}
                    view={menuView}
                    onStartSandbox={startSandbox}
                    onOpenTutorials={openTutorials}
                    onBack={backToMain}
                    onStartTutorial={startTutorial}
                    showQuitTutorial={Boolean(activeTutorial)}
                    onQuitTutorial={quitTutorial}
                />
            ) : (
                <>
                    <HexMapCanvas
                        configOverride={configOverride || undefined}
                        tutorialId={tutorialId}
                    />
                    <button
                        type="button"
                        className="app__menu-toggle"
                        onClick={() => setMode('menu')}
                    >
                        {t(lang, 'menu.open')}
                    </button>
                    {activeTutorial ? (
                        <button
                            type="button"
                            className="app__menu-toggle"
                            style={{ top: 48 }}
                            onClick={() => {
                                setMode('menu');
                                setMenuView('main');
                            }}
                        >
                            {t(lang, 'menu.quitTutorial')}
                        </button>
                    ) : null}
                </>
            )}
        </div>
    );
};

export default App;
